export default __webpack_public_path__ + "static/media/success.25ac0aaf.png";